<template>
  <section class="switch-inputs">
    <section-title>SwitchInput Component</section-title>
    <form-wrap>
      <form-field-set>
        <switch-input
          v-model="switchInput"
          :direction="direction"
          label="Switch Input"
          name="switchInput1"
        />

        <switch-input
          v-model="switchInput"
          :direction="direction"
          label="Switch Input"
          hint="Team Account ist öffentlich sichtbar"
          name="switchInput2"
        />

        <switch-input
          v-model="switchInput"
          :direction="direction"
          :is-disabled="true"
          label="Switch Input Disabled"
          name="switchInput3"
        />

        <switch-input
          v-model="switchInput"
          :direction="direction"
          error="Bitte die Nutzungsbedingungen akzeptieren."
          label="Switch Input Error"
          name="switchInput4"
        />
      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import PlaygroundCommmonMixin from '@/mixins/pages/playground/PlaygroundCommon'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import SectionTitle from '@/components/ui/SectionTitle'
import SwitchInput from '@/components/forms/SwitchInput'

export default {
  name: 'SwitchInputs',
  mixins: [PlaygroundCommmonMixin],
  components: {
    FormFieldSet,
    FormWrap,
    SectionTitle,
    SwitchInput
  },
  data () {
    return {
      switchInput: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/SwitchInputs.vue